export const PIE_CHART_MARGIN = {
    bottom: 30,
    left: 40,
    right: 10,
    top: 30,
}

export const PIE_CHART_THEME = {
    text: {
        fontSize: 14,
    },
}
